/**
 * Object templates only override the fields they explicitly set; every other
 * field is inherited (defaults → global design → object template). A
 * KAIA-seeded template carries only an id/name/type plus a few overrides, so it
 * is *missing* most design keys. The Map Builder's template panel builds a renderable
 * template from every key, so those gaps must be present — but as **null**, not
 * filled with the defaults' values: a real value would shadow the global-design
 * layer and break inheritance, whereas null means "not set, inherit".
 */
export function fillTemplateGapsWithNull<T extends Record<string, unknown>>(
  template: T,
  keySource: Record<string, unknown>,
): T & Record<string, null> {
  const gaps: Record<string, null> = {};
  for (const key of Object.keys(keySource)) {
    // `in` (not falsy): a field the template sets to false/0/'' is intentional
    // and must be kept, only genuinely absent fields become null.
    if (!(key in template)) gaps[key] = null;
  }
  return { ...gaps, ...template };
}
